import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NextRouter } from 'next/router';
import React from 'react';
import ReactPaginate from 'react-paginate';
import Button from '../button/button.component';
import styles from './pagination.module.scss';
type Props = {
  router: NextRouter;
  nbHits: number;
  pageSize?: number;
};

const Pagination: React.FC<Props> = ({ router, nbHits, pageSize = 50 }) => {
  const onPageChange = ({ selected }: { selected: number }) => {
    if (selected < 0) {
      router.push({
        pathname: router.pathname,
        query: {
          ...router.query,
          page: null,
        },
      });
    } else if (selected > Math.ceil(nbHits / pageSize)) {
      router.push({
        pathname: router.pathname,
        query: {
          ...router.query,
          page: Math.ceil(nbHits / pageSize),
        },
      });
    }
  };
  const onClick = ({
    nextSelectedPage,
  }: {
    nextSelectedPage: number | undefined;
  }) => {
    router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        page: (nextSelectedPage || 0) + 1,
      },
    });
  };
  return nbHits > pageSize ? (
    <ReactPaginate
      className={styles.paginationWrapper}
      initialPage={
        router.query.page && Number(router.query.page) > 0
          ? Number(router.query.page) - 1
          : 0
      }
      breakLabel="..."
      nextLabel={
        Number(router.query.page) !== Math.ceil(nbHits / pageSize) ? (
          <Button small={true} btn={true}>
            Next <FontAwesomeIcon icon={faChevronRight} />
          </Button>
        ) : (
          ''
        )
      }
      onPageChange={onPageChange}
      onClick={onClick}
      pageRangeDisplayed={3}
      pageCount={Math.ceil(nbHits / pageSize)}
      previousLabel={
        router.query.page && Number(router.query.page) !== 1 ? (
          <Button small={true} btn={true}>
            <FontAwesomeIcon icon={faChevronLeft} /> Previous
          </Button>
        ) : (
          ''
        )
      }
    />
  ) : null;
};

export default Pagination;
